import React from 'react';
import BaseIcon from './BaseIcon.js';

const IconSuperitem = function ({ size }) {
  return (
    <BaseIcon viewBox="0 0 48 48" size={size}>
      <g>
        <polygon fill="currentColor" points="26.068,24.846 26.068,47.987 45.285,38.04 45.285,14.898  ">
        </polygon>
        <polygon fill="currentColor" points="2.715,36.078 21.872,47.987 21.872,24.71 2.715,13.069  ">
        </polygon>
        <path d="M23.497,0.013L4.89,9.571c0.04-0.054,19.08,12.026,19.08,12.026L43.188,11.38L23.497,0.013z" fill="currentColor">
        </path>
      </g>
    </BaseIcon>
  );
}

export default IconSuperitem;
